import type { IConfigPortalCredentialRepository } from "@src/domain/repositories/config";
import type { CreateConfigPortalCredentialDTO } from "@src/domain/dto/config";

export class CreateConfigPortalCredentialUseCase {
  private readonly repository: IConfigPortalCredentialRepository;

  constructor(repository: IConfigPortalCredentialRepository) {
    this.repository = repository;
  }

  execute(params: CreateConfigPortalCredentialDTO) {
    return this.repository.createPortalCredential(params);
  }
}
